import React, { useEffect, useState } from 'react'
import Support from '../../../assets/img/support/support.png'
import Header from '../../common/header/Header'
import Footer from '../../common/footer/Footer'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../config/Config';
import { Get_Custom_Designs, custom_jewellery } from '../../../api/global/Global'
import { Helmet } from 'react-helmet'
import Loader from '../../../loader/Loader'
import { isAlphabetical, isValidEmail } from '../../validation/Validation';
import { toast } from 'react-toastify';

const Custom_Jewelry = () => {

    const [showModal, setShowModal] = useState(false);
    const [customDesigns, setCustomdesigns] = useState(null)
    const [customJewellery, setCustomJewellery] = useState(null)
    const [show_video, set_show_video] = useState(false)
    const [video, set_video] = useState(null)
    const [selectedDesignId, setSelectedDesignId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // Form states for modal (Write to Us)
    const [modalForm, setModalForm] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        country_code: '+91' // Default country code
    });

    // Form states for main form (Looking for detailed discussion)
    const [mainForm, setMainForm] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        image: null,
        country_code: '+91' // Default country code
    });

    // Handle modal form input changes
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone" && value.length > 10) {
            return
        }

        if (name === "name" && value?.length && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        } 

        if (name === "email") {
            if (!isValidEmail(value)) {
                setErrorMessage("Please enter a valid email address");
            } else {
                setErrorMessage("");
            }
        }
        setModalForm(prev => ({
            ...prev,
            [name]: value
        }));
    };
    // Handle main form input changes
    const handleMainInputChange = (e) => {
        const { name, value, files } = e.target;
        resetMessages(); // Reset messages on input change
        if (name === "phone" && value.length > 10) {
            return
        }
        if( name === "name" && value?.length && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        if (name === "email") {
            if (!isValidEmail(value)) {
                setErrorMessage("Please enter a valid email address");
            } else {
                setErrorMessage("");
            }
        }
        if (name === 'image') {
            setMainForm(prev => ({
                ...prev,
                [name]: files[0]
            }));
        } else {
            setMainForm(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    // Reset messages
    const resetMessages = () => {
        setSuccessMessage('');
        setErrorMessage('');
    };

    // Submit modal form (Write to Us)
    const handleModalSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        resetMessages();

        if (!modalForm.name || !isAlphabetical(modalForm.name)) {
            toast("Name should only contain alphabetic characters");
            setLoading(false)
            return;
        }

        if (!modalForm.email || !isValidEmail(modalForm.email)) {
            toast("Please enter a valid email address.");
            setLoading(false)
            return;
        }

        try {
            const formData = new FormData();
            formData.append('name', modalForm.name);
            formData.append('email', modalForm.email);
            formData.append('country_code', modalForm.country_code);
            formData.append('mobile', modalForm.phone);
            formData.append('message', modalForm.message);

            if (selectedDesignId) {
                formData.append('custom_design_id', selectedDesignId?.id);
            }

            const response = await custom_jewellery({
                method: 'POST',
                body: formData,
            })

            // Adjust based on your API response structure
            const result = response.data;

            if (result?.status == 200) {
                setLoading(false);
                setSuccessMessage(result?.message || 'Your request has been submitted successfully!');
                setModalForm({
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    country_code: '+91'
                });

                setTimeout(() => {
                    setShowModal(false);
                    setSuccessMessage('');
                }, 2000);
            }
            if (response?.response?.data?.status == 500) {
                setLoading(false);
                setErrorMessage(response?.response?.data?.message || 'Failed to submit your request.');
            }
        } catch (error) {
            console.error('Error submitting modal form:', error);
            setErrorMessage('Failed to submit your request. Please try again.');
        } finally {
            setLoading(false);
        }
    };


     const closePopUp = () => {
        setShowModal(false)
        setModalForm({
            name: '',
            email: '',
            phone: '',
            message: '',
            country_code: '+91'
        });

    }

    // Submit main form (Looking for detailed discussion)
    const handleMainSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        resetMessages();

        if(!mainForm?.name || !isAlphabetical(mainForm.name)){
            toast("Name should only contain alphabetic characters");
            setLoading(false)
            return;
        }

        if(!mainForm?.email || !isValidEmail(mainForm.email)){
             toast("Please enter a valid email address.");
            setLoading(false)
            return;
        }

        try {
            const formData = new FormData();
            formData.append('name', mainForm.name);
            formData.append('email', mainForm.email);
            formData.append('country_code', mainForm.country_code);
            formData.append('mobile', mainForm.phone);
            formData.append('message', mainForm.message);
            if (mainForm.image) {
                formData.append('image', mainForm.image);
            }

            const response = await custom_jewellery({
                method: 'POST',
                body: formData,
            })

            const result = response.data;

            if (result?.status == 200) {
                setSuccessMessage(result?.message);
                setLoading(false);
                setMainForm({
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    image: null,
                    country_code: '+91'
                });

                // Clear file input
                const fileInput = document.querySelector('input[type="file"]');
                if (fileInput) fileInput.value = '';

                setTimeout(() => {
                    setSuccessMessage('');
                }, 2000);
            }
            if (response?.response?.data?.status == 500) {
                setErrorMessage(response?.response?.data?.message || 'Failed to submit your request.');
            }
        } catch (error) {
            console.error('Error submitting main form:', error);
            setErrorMessage('Failed to submit your request. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    // Handle Write to Us button click
    const handleWriteToUs = (designId) => {
        setSelectedDesignId(designId);
        setShowModal(true);
        resetMessages();
    };

    const handlePlay_Video = (video_url) => {
        set_video(video_url)
        set_show_video(!show_video)
    }

    useEffect(() => {
        const getcustom_designs = async () => {
            setLoading(true)
            try {
                const response = await Get_Custom_Designs()
                if (response?.data?.status == 200) {
                    setCustomdesigns(response?.data?.data?.custom_design)
                    setCustomJewellery(response?.data?.data?.custom_jewellery)
                }

            } catch (error) {
                console.error(error.message);

            } finally {
                setLoading(false)
            }
        }
        getcustom_designs()
    }, [])

    // if (!isOpen) return null;

    return (
        <div>
            <>
                <Helmet>
                    <title>{customJewellery?.meta_title}</title>
                    <meta name="description" content={customJewellery?.meta_description
                        || "description"} />
                    <link rel="canonical" href={`${WEB_DOMAIN_KEY}custom-jewelry`} />
                    <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}custom-jewelry`} />

                </Helmet>
                <Header />

                <section className="relative gi-terms-conditions bg-center bg-no-repeat bg-cover py-[100px] max-[767px]:py-[30px]" style={{ backgroundImage: `url(${IMG_BASE_URL}${customJewellery?.banner_img})` }}>
                    <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-[#000000] to-gray-950 opacity-60"></div>
                    <div className="flex flex-wrap justify-between items-center mx-auto min-[1600px]:max-w-[1400px] min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                        <div className="section-title-2 text-center min-[1600px]:max-w-[600px] mx-auto z-20 relative">
                            <h1 className="text-white bodonibook_font text-5xl font-medium">{customJewellery?.banner_title
                            }</h1>
                            <h2 className="text-white bodonibook_font text-2xl font-medium">{customJewellery?.banner_sub_title}</h2>
                            <div className="text-white text-[13px] font-medium py-5">{customJewellery?.banner_description}</div>
                            <a className="text-[13px] uppercase inline-block border border-gray-400 text-white font-semibold px-6 py-3 hover:bg-red-700 hover:text-white" href="#custome_jewellery_form">Start The Process</a>
                        </div>

                    </div>
                </section>
                <section className="relative gi-terms-conditions py-[40px] max-[767px]:py-[30px]">
                    <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                        <div className="section-title-2 text-center min-[1600px]:max-w-[600px] mx-auto z-20 relative">
                            <h1 className="text-gray-900 bodonibook_font text-3xl font-medium">Customised Jewelry</h1>
                            <p className="text-gray-600 text-[14px] font-medium pt-3 capitalize">our latest designs done on special requests</p>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 my-6">
                            <div className="border border-gray-100 p-6 rounded-lg relative">
                                <span className='absolute bottom-0 right-3 text-red-100 text-[100px] text-semibold bodonibook_font -z-10'>01</span>
                                <svg width="55" height="55" viewBox="0 0 68 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M27.4375 28.4375C29.2487 28.4375 30.7187 26.9697 30.7187 25.1562C30.7187 23.345 29.2487 21.875 27.4375 21.875C25.6262 21.875 24.1562 23.345 24.1562 25.1562C24.1561 26.9696 25.6262 28.4375 27.4375 28.4375ZM40.5624 28.4375C42.3737 28.4375 43.8436 26.9697 43.8436 25.1562C43.8436 23.345 42.3736 21.875 40.5624 21.875C38.7512 21.875 37.2812 23.345 37.2812 25.1562C37.2811 26.9696 38.7512 28.4375 40.5624 28.4375ZM21.1724 49.737C22.8742 50.0127 26.7395 50.3123 28.5311 50.3123C44.2374 50.3123 54.7811 38.6245 54.7811 24.8827C54.7811 11.1408 41.6058 0 28.5311 0C12.8031 0 0.09375 11.1409 0.09375 24.8827C0.09375 32.843 3.12779 39.6024 8.84375 44.4696V56.8748L21.1724 49.737ZM4.46875 25.1561C4.46875 13.6784 14.8659 4.375 28.5311 4.375C39.4096 4.375 50.406 13.6784 50.406 25.1561C50.406 36.6339 41.8201 45.9374 28.5311 45.9374C26.5778 45.9374 22.5024 45.7142 20.6846 45.3357L13.2187 50.3123V42.56C7.88341 38.2308 4.46875 32.4471 4.46875 25.1561ZM59.0444 19.9893C59.086 20.6171 59.156 21.2384 59.156 21.875C59.156 23.2663 59.0226 24.629 58.8257 25.9744C61.7701 29.4219 63.531 33.6678 63.531 38.2812C63.531 45.5722 59.1736 51.9771 52.5936 55.6848V63.4374L45.1276 58.4608C43.3099 58.8392 41.4221 59.0624 39.4686 59.0624C33.8031 59.0624 30.7931 57.3605 26.6806 54.5299C25.4884 54.6262 24.2831 54.6875 23.0625 54.6875C22.1919 54.6875 21.3387 54.624 20.4812 54.5759C25.6875 59.6684 31.0446 62.8906 39.4686 62.8906C41.2602 62.8906 43.0079 62.7287 44.7077 62.4508L56.9685 69.9999V57.5923C63.6163 53.0379 67.906 45.9681 67.906 38.0055C67.906 30.9093 64.4935 24.524 59.0444 19.9893ZM14.3125 28.4375C16.1237 28.4375 17.5937 26.9697 17.5937 25.1562C17.5937 23.345 16.1237 21.875 14.3125 21.875C12.5012 21.875 11.0312 23.345 11.0312 25.1562C11.0312 26.9696 12.5012 28.4375 14.3125 28.4375Z" fill="#9D2326" />
                                </svg>

                                <div className="text-gray-800 text-[14px] font-medium pt-3">
                                    Share your Idea or Design with us and get a free Jewelry Consultation
                                </div>
                            </div>
                            <div className="border border-gray-100 p-6 rounded-lg relative">
                                <span className='absolute bottom-0 right-3 text-red-100 text-[100px] text-semibold bodonibook_font -z-10'>02</span>
                                <svg width="55" height="55" viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M81.7667 37.3067L71.5108 16.7949C71.2978 16.3721 70.9718 16.0165 70.569 15.7676C70.1662 15.5187 69.7024 15.3862 69.2289 15.3848H12.8217C12.3482 15.3862 11.8844 15.5187 11.4816 15.7676C11.0788 16.0165 10.7528 16.3721 10.5398 16.7949L0.283901 37.3067C0.294772 37.3832 0.294772 37.4609 0.283901 37.5374C0.271754 37.7595 0.271754 37.982 0.283901 38.2041L0.00186492 38.4604C-0.000621641 38.5031 -0.000621641 38.546 0.00186492 38.5886C0.0259152 38.833 0.0775225 39.0738 0.155703 39.3066C0.155703 39.3066 0.155703 39.4348 0.155703 39.5117C0.260634 39.7715 0.417702 40.0071 0.617216 40.2039L39.0767 81.2274C39.3165 81.4836 39.6064 81.6878 39.9283 81.8274C40.2503 81.967 40.5975 82.039 40.9484 82.039C41.2993 82.039 41.6465 81.967 41.9684 81.8274C42.2904 81.6878 42.5802 81.4836 42.8201 81.2274L81.2796 40.2039C81.6479 39.8291 81.8921 39.3502 81.9793 38.832C82.0664 38.3138 81.9922 37.7813 81.7667 37.3067ZM41.0253 22.7946L49.23 35.8965H32.8206L41.0253 22.7946ZM28.0004 33.9222L17.9496 20.5127H36.4102L28.0004 33.9222ZM45.6404 20.5127H64.101L54.0502 33.9222L45.6404 20.5127ZM50.3581 41.0244L41.0253 70.8946L31.6925 41.0244H50.3581ZM35.2564 69.587L8.48859 41.0244H26.4363L35.2564 69.587ZM55.7681 41.0244H73.7159L46.7942 69.587L55.7681 41.0244ZM75.3824 35.8965H58.9731L68.793 22.7946L75.3824 35.8965ZM13.2576 22.7946L23.0775 35.8965H6.71945L13.2576 22.7946Z" fill="#9D2326" />
                                    <path d="M41.0249 10.2559C41.7049 10.2559 42.3571 9.98573 42.8379 9.50489C43.3187 9.02405 43.5889 8.3719 43.5889 7.69189V2.56396C43.5889 1.88396 43.3187 1.2318 42.8379 0.750968C42.3571 0.270131 41.7049 0 41.0249 0C40.3449 0 39.6927 0.270131 39.2119 0.750968C38.7311 1.2318 38.4609 1.88396 38.4609 2.56396V7.69189C38.4609 8.3719 38.7311 9.02405 39.2119 9.50489C39.6927 9.98573 40.3449 10.2559 41.0249 10.2559Z" fill="#9D2326" />
                                    <path d="M26.3844 9.51352C26.6228 9.75384 26.9063 9.94458 27.2188 10.0748C27.5312 10.2049 27.8664 10.2719 28.2048 10.2719C28.5433 10.2719 28.8784 10.2049 29.1909 10.0748C29.5033 9.94458 29.7869 9.75384 30.0252 9.51352C30.2656 9.27517 30.4563 8.99159 30.5865 8.67915C30.7166 8.36671 30.7837 8.03158 30.7837 7.69311C30.7837 7.35463 30.7166 7.01951 30.5865 6.70707C30.4563 6.39462 30.2656 6.11105 30.0252 5.87269L27.4613 3.30873C26.9785 2.82592 26.3236 2.55469 25.6409 2.55469C24.9581 2.55469 24.3032 2.82592 23.8204 3.30873C23.3376 3.79153 23.0664 4.44636 23.0664 5.12914C23.0664 5.81193 23.3376 6.46675 23.8204 6.94956L26.3844 9.51352Z" fill="#9D2326" />
                                    <path d="M53.8459 10.2571C54.1834 10.259 54.5179 10.1943 54.8302 10.0668C55.1426 9.93916 55.4268 9.75116 55.6663 9.51352L58.2303 6.94956C58.7131 6.46675 58.9843 5.81193 58.9843 5.12914C58.9843 4.44636 58.7131 3.79153 58.2303 3.30873C57.7475 2.82592 57.0927 2.55469 56.4099 2.55469C55.7271 2.55469 55.0723 2.82592 54.5895 3.30873L52.0255 5.87269C51.7852 6.11105 51.5944 6.39462 51.4643 6.70707C51.3341 7.01951 51.2671 7.35463 51.2671 7.69311C51.2671 8.03158 51.3341 8.36671 51.4643 8.67915C51.5944 8.99159 51.7852 9.27517 52.0255 9.51352C52.2651 9.75116 52.5492 9.93916 52.8616 10.0668C53.174 10.1943 53.5085 10.259 53.8459 10.2571Z" fill="#9D2326" />
                                </svg>
                                <div className="text-gray-800 text-[14px] font-medium pt-3">
                                    Watch your Idea get
                                    a life and receive a
                                    quote for your creation
                                </div>
                            </div>
                            <div className="border border-gray-100 p-6 rounded-lg relative">
                                <span className='absolute bottom-0 right-3 text-red-100 text-[100px] text-semibold bodonibook_font -z-10'>03</span>
                                <svg width="55" height="55" viewBox="0 0 58 83" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M39.581 9.29552C39.581 9.05964 39.3897 8.9082 39.1538 8.9082H18.2915C18.0556 8.9082 17.8643 9.05964 17.8643 9.29552C17.8643 9.5314 18.0556 9.68284 18.2915 9.68284H39.1538C39.3864 9.68284 39.581 9.53469 39.581 9.29552Z" fill="#9D2326" />
                                    <path d="M23.6397 7.80879C23.79 7.95229 24.0191 7.96933 24.1899 7.84984L28.7144 4.55899L33.027 7.84636C33.1056 7.90097 33.1978 7.93176 33.2867 7.93176C33.3994 7.93176 33.5156 7.88393 33.601 7.79852L36.861 4.31982C37.0216 4.14553 37.0113 3.87557 36.8405 3.71503C36.6697 3.54751 36.3997 3.56475 36.2357 3.73207L33.2388 6.93054L28.9809 3.68753C28.8306 3.57482 28.622 3.57133 28.4717 3.68075L23.9814 6.94758L21.0528 4.08395C20.8853 3.9234 20.6121 3.91992 20.448 4.09421C20.284 4.25824 20.2875 4.53169 20.4548 4.69572L23.6397 7.80879Z" fill="#9D2326" />
                                    <path d="M28.9739 20.0978L32.8833 11.0454C32.9755 10.8301 32.8765 10.5773 32.6612 10.4817C32.4356 10.386 32.1896 10.4919 32.0972 10.7073L28.557 18.8985L24.617 10.6935C24.5145 10.4817 24.2616 10.3895 24.0463 10.4919C23.8344 10.5911 23.7422 10.8473 23.8447 11.0592L28.1913 20.1116C28.2632 20.2619 28.4135 20.3542 28.5775 20.3542C28.7586 20.3746 28.9021 20.2551 28.9739 20.0978Z" fill="#9D2326" />
                                    <path d="M34.6216 25.7106C34.8156 25.3968 34.9436 25.0293 34.9436 24.6354V24.5054C34.9436 23.3743 33.9901 22.4643 32.8591 22.4643H32.172L43.9174 10.0447C44.4641 9.46373 44.5394 8.58161 44.0985 7.91852L39.2698 0.719831C38.9518 0.244979 38.4188 0 37.8481 0H19.6889C19.1422 0 18.6261 0.219028 18.305 0.666574L13.0869 7.8856C12.6086 8.5485 12.6699 9.45792 13.2339 10.0559L24.9818 22.4644H24.7258C23.5946 22.4644 22.7429 23.3745 22.7429 24.5056V24.6356C22.7429 25.0295 22.82 25.3972 23.0141 25.7108C9.90547 28.4086 0 40.0394 0 53.9315C0 69.8183 12.9147 82.7424 28.8015 82.7424C44.6919 82.7424 57.618 69.8183 57.618 53.9315C57.6182 40.0363 47.7309 28.4078 34.6216 25.7106ZM20.5637 3.2922H36.9358L40.4999 8.6585L28.5771 21.2671L16.6851 8.69142L20.5637 3.2922ZM28.7924 78.6451C15.1678 78.6451 4.08233 67.5562 4.08233 53.9315C4.08233 40.3068 15.168 29.2214 28.7924 29.2214C42.4204 29.2214 53.5026 40.3035 53.5026 53.9315C53.5026 67.5595 42.4169 78.6451 28.7924 78.6451Z" fill="#9D2326" />
                                    <path d="M28.7927 31.7227C16.5453 31.7227 6.58057 41.6874 6.58057 53.9348C6.58057 66.1822 16.5451 76.1469 28.7927 76.1469C41.0403 76.1469 51.0048 66.1789 51.0048 53.9348C51.0048 41.6874 41.0401 31.7227 28.7927 31.7227ZM28.7927 72.7298C18.428 72.7298 9.99768 64.2959 9.99768 53.935C9.99768 43.574 18.428 35.1402 28.7927 35.1402C39.1571 35.1402 47.5875 43.5705 47.5875 53.935C47.5875 64.2959 39.1571 72.7298 28.7927 72.7298Z" fill="#9D2326" />
                                </svg>

                                <div className="text-gray-800 text-[14px] font-medium pt-3">
                                    View the final customised
                                    creation through HD
                                    pictures and Videos
                                </div>
                            </div>
                            <div className="border border-gray-100 p-6 rounded-lg relative">
                                <span className='absolute bottom-0 right-3 text-red-100 text-[100px] text-semibold bodonibook_font -z-10'>04</span>
                                <svg width="55" height="55" viewBox="0 0 70 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.68441 60.9748C2.44716 61.008 2.20645 61.008 1.96919 60.9748C1.48736 60.8184 1.0704 60.5077 0.782691 60.0907C0.494981 59.6738 0.35251 59.1737 0.37727 58.6677V56.3605C0.378183 45.935 4.09486 35.851 10.8602 27.9186C17.6256 19.9862 26.9967 14.7248 37.2915 13.0787V3.2964C37.2915 2.86793 37.4108 2.44793 37.636 2.08346C37.8613 1.71899 38.1836 1.42444 38.5668 1.23283C38.95 1.04122 39.3791 0.960103 39.8058 0.998581C40.2325 1.03706 40.6401 1.19361 40.9829 1.45069L68.6685 22.2149C68.9551 22.4298 69.1876 22.7085 69.3478 23.0288C69.508 23.3492 69.5914 23.7025 69.5914 24.0606C69.5914 24.4188 69.508 24.7721 69.3478 25.0924C69.1876 25.4128 68.9551 25.6914 68.6685 25.9063L40.9829 46.6706C40.6401 46.9276 40.2325 47.0842 39.8058 47.1227C39.3791 47.1612 38.95 47.08 38.5668 46.8884C38.1836 46.6968 37.8613 46.4023 37.636 46.0378C37.4108 45.6733 37.2915 45.2533 37.2915 44.8249V36.1731C26.1195 37.9965 16.1151 44.1466 9.44432 53.2921L4.55319 60.0289C4.33841 60.3228 4.05713 60.5617 3.73233 60.7262C3.40753 60.8906 3.04844 60.9758 2.68441 60.9748ZM41.9057 7.91067V15.1089C41.9092 15.6793 41.7013 16.2307 41.3221 16.6568C40.9429 17.0828 40.4193 17.3533 39.8524 17.4161C31.1529 18.3652 23.0207 22.1964 16.7497 28.3002C10.4787 34.4039 6.42916 42.4296 5.24533 51.1003L5.61447 50.6158C9.56259 45.1947 14.6092 40.6668 20.4252 37.3275C26.2411 33.9882 32.6957 31.9125 39.3679 31.2358C39.6895 31.2059 40.0138 31.2438 40.3198 31.3471C40.6258 31.4505 40.9068 31.6169 41.1444 31.8357C41.3834 32.0514 41.5746 32.3147 41.7057 32.6088C41.8368 32.9028 41.905 33.221 41.9057 33.543V40.2106L63.4313 24.0606L41.9057 7.91067Z" fill="#9D2326" />
                                </svg>

                                <div className="text-gray-800 text-[14px] font-medium pt-3">
                                    Own your Bespoke
                                    creation and treasure
                                    it for a lifetime
                                </div>
                            </div>
                        </div>
                        <div className="text-center w-full">
                            <a className="text-[13px] mx-auto uppercase inline-block border border-gray-400 text-gray-800 font-semibold px-6 py-3 hover:bg-red-700 hover:text-white" href="#custome_jewellery_form">Start The Process</a>
                        </div>
                    </div>
                </section>
                {/* custome jewellery form */}
                <section className="relative bg-gray-100 pt-[40px]" id="custome_jewellery_form">
                    <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">

                        <div className="gi-bl-block-content grid md:grid-cols-3 items-end mt-[60px]">

                            <div className="gi-check-bill-form pb-4 col-span-2 my-auto">
                                <div className="section-title-2 relative pb-6">
                                    <h2 className="text-gray-900 bodonibook_font text-3xl font-medium">Looking for a detailed discussion?</h2>
                                    <div className="text-gray-600 text-[14px] font-medium pt-1 capitalize">Submit Your Designs Here to Get Started!</div>
                                    <div className="border-b border-gray-600 mt-3 w-[150px]"></div>
                                </div>

                                {successMessage && (
                                    <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
                                        {successMessage}
                                    </div>
                                )}

                                {errorMessage && (
                                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                                        {errorMessage}
                                    </div>
                                )}

                                <form onSubmit={handleMainSubmit} className="flex flex-row flex-wrap">
                                    <div className="gi-bill-wrap gi-bill-half w-[50%] px-[6px] mb-3">
                                        <label
                                            className="text-gray-700 font-medium text-[13px] inline-block">Name</label>
                                        <input type="text"
                                            name="name"
                                            value={mainForm.name}
                                            onChange={handleMainInputChange}
                                            placeholder="Enter your name"
                                            className="input-field placeholder:text-sm text-[13px] w-full border border-gray-200 px-4 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                            required />
                                    </div>

                                    <div className="gi-bill-wrap gi-bill-half w-[50%] px-[6px] mb-3">
                                        <label
                                            className="text-gray-700 font-medium text-[13px] inline-block">Email ID </label>
                                        <input type="email"
                                            name="email"
                                            value={mainForm.email}
                                            onChange={handleMainInputChange}
                                            placeholder="Enter Your Email Address"
                                            className="input-field placeholder:text-sm text-[13px] w-full border border-gray-200 px-4 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                            required />
                                    </div>
                                    <div className="gi-bill-wrap gi-bill-half w-[50%] px-[6px] mb-3">
                                        <label
                                            className="text-gray-700 font-medium text-[13px] inline-block">Phone
                                            Number </label>
                                        <input type="number"
                                            name="phone"
                                            value={mainForm.phone}
                                            onChange={handleMainInputChange}
                                            placeholder="Enter Your Phone Number"
                                            className="input-field placeholder:text-sm text-[13px] w-full border border-gray-200 px-4 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                            required />
                                    </div>
                                    <div className="gi-bill-wrap gi-bill-half w-[50%] px-[6px] mb-3">
                                        <label
                                            className="text-gray-700 font-medium text-[13px] inline-block">Upload Your Design </label>
                                        <input type="file"
                                            name="image"
                                            onChange={handleMainInputChange}
                                            className="input-field placeholder:text-sm text-[13px] w-full border border-gray-200 px-4 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                            required />
                                    </div>
                                    <div className="gi-bill-wrap gi-bill-half w-[100%] px-[6px] mb-3">
                                        <label
                                            className="text-gray-700 font-medium text-[13px] inline-block">Message </label>
                                        <textarea
                                            placeholder="Enter Your Message Here"
                                            name='message'
                                            value={mainForm.message}
                                            onChange={handleMainInputChange}
                                            rows="4"
                                            className="input-field placeholder:text-sm text-[13px] w-full border border-gray-200 p-4 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none"
                                            required />
                                    </div>


                                    <div className="w-full px-[6px] mb-3">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="text-[13px] mx-auto w-full uppercase inline-block border border-red-700 bg-red-700 text-white font-semibold px-6 py-3 hover:bg-red-800 hover:text-white disabled:opacity-50"
                                        >
                                            {loading ? 'SUBMITTING...' : 'SUBMIT'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div>
                                <img src={Support} alt="support" />
                            </div>
                        </div>

                    </div>
                </section >
                {/* popup */}
                <div className={`p-10 ${!showModal ? 'hidden' : 'block'} fixed inset-0 z-30 bg-gray-950/90 h-full overflow-hidden`}>

                    <div className="flex h-full justify-center items-center">
                        <div className="mx-auto bg-white p-5 w-[500px] rounded relative">
                            <div isOpen={showModal} onClose={() => setShowModal(false)}>
                                <button
                                    onClick={closePopUp}
                                    className="absolute -top-4 -right-4 font-bold text-xl bg-red-700 text-white w-8 h-8 text-center inline-block rounded-full pb-1 border border-white">x</button>
                                <div>
                                    <div className="text font-semibold text-lg">Submit Your Request</div>
                                    <div className="text-gray-700 text-[13px] font-medium mb-4">18K Yellow Gold Blue Sapphire With Diamond Ring</div>
                                </div>
                                <div className="grid grid-cols-2 gap-3">
                                    <div>
                                        <img className="w-full" src={`${IMG_BASE_URL}${selectedDesignId?.thumbnail_img}`} alt="jewellery" />
                                    </div>
                                    <div>
                                        <form onSubmit={handleModalSubmit} className="flex flex-row flex-wrap">
                                            <div className="w-full px-[6px] mb-1">
                                                <label
                                                    className="text-gray-700 font-medium text-[12px] inline-block">Name</label>
                                                <input type="text"
                                                    placeholder="Enter your name"
                                                    name="name"
                                                    value={modalForm.name}
                                                    onChange={handleModalInputChange}
                                                    className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                    required />
                                            </div>

                                            <div className="w-full px-[6px] mb-1">
                                                <label
                                                    className="text-gray-700 font-medium text-[12px] inline-block">Email ID </label>
                                                <input type="email"
                                                    name="email"
                                                    placeholder="Enter your e-mail here"
                                                    value={modalForm.email}
                                                    onChange={handleModalInputChange}
                                                    className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                    required />
                                            </div>
                                            <div className="w-full px-[6px] mb-1">
                                                <label
                                                    className="text-gray-700 font-medium text-[12px] inline-block">Phone Number </label>
                                                <input type="number"
                                                    name="phone"
                                                    placeholder="Enter Your Phone Number Here"
                                                    value={modalForm.phone}
                                                    onChange={handleModalInputChange}
                                                    className="input-field text-[12px] w-full border border-gray-200 px-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none h-[33px]"
                                                    required />
                                            </div>

                                            <div className="w-full px-[6px] mb-1">
                                                <label
                                                    className="text-gray-700 font-medium text-[12px] inline-block">Message </label>
                                                <textarea
                                                    placeholder="Enter Your Message Here"
                                                    name='message'
                                                    value={modalForm.message}
                                                    onChange={handleModalInputChange}
                                                    className="input-field text-[12px] w-full border border-gray-200 p-3 text-gray-600  font-medium bg-white focus:ring-0 focus:outline-none"
                                                    required />
                                            </div>

                                            {successMessage && (
                                                <div className="bg-green-100 border border-green-400 text-green-700 px-3 py-2 rounded text-xs">
                                                    {successMessage}
                                                </div>
                                            )}

                                            {errorMessage && (
                                                <div className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded text-xs">
                                                    {errorMessage}
                                                </div>
                                            )}

                                            <div className="w-full px-[6px]">
                                                <button type="submit"
                                                    disabled={loading}
                                                    className="text-[12px] mx-auto w-full uppercase inline-block border border-red-700 bg-red-700 text-white font-semibold px-6 py-2 hover:bg-red-700 hover:text-white">
                                                    {loading ? 'SUBMITTING...' : 'SUBMIT'}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* popup end */}

                <section className="relative gi-terms-conditions py-[40px] max-[767px]:py-[30px]">
                    <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                        <div className="section-title-2 text-center min-[1600px]:max-w-[600px] mx-auto z-20 relative">
                            <h2 className="text-gray-900 bodonibook_font text-3xl font-medium">Get Some Inspiration</h2>
                            <p className="text-gray-600 text-[14px] font-medium pt-3 capitalize">SOME OF OUR EXCLUSIVE CUSTOM DESIGNS</p>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-1 my-6 w-full">
                            {customDesigns?.map((designs) => (
                                <div className="rounded-lg relative overflow-hidden">
                                    <div className="product_jewellery relative">
                                        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-[#000000] to-gray-950 opacity-80"></div>
                                        <img className="w-full h-[360px] object-cover" src={`${IMG_BASE_URL}${designs?.thumbnail_img}`} alt="jewellery" />
                                    </div>
                                    <div className="absolute inset-0 w-full h-full cursor-pointer">
                                        <div className="flex flex-col justify-between gap-6 h-full text-center items-center p-6">
                                            <span className='text-[20px] text-white text-semibold bodonibook_font'></span>
                                            {designs?.video && (
                                                <span className='text-[25px] text-white text-semibold bodonibook_font' onClick={() => handlePlay_Video(`${IMG_BASE_URL}${designs?.video}`)}><i className="fi-rr-play"></i></span>
                                            )}
                                            <button className="text-[13px] w-full mx-auto uppercase rounded-full inline-block border border-gray-200 text-white font-semibold px-7 py-2.5 hover:bg-red-700 hover:text-white hover:border-red-700" onClick={() => handleWriteToUs(designs)}>Write to Us</button>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                        {
                            show_video == true && (
                                <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/10 backdrop-blur-[2px]">
                                    <div className='relative'>
                                        {/* Close Button */}
                                        <button
                                            onClick={() => set_show_video(false)}
                                            className="absolute -top-6 -right-6 text-white bg-black bg-opacity-60 rounded-full w-8 h-8 flex items-center justify-center text-xl hover:bg-opacity-80 z-30"
                                        >
                                            &times;
                                        </button>

                                        {/* Video Modal */}
                                        <div className="w-full max-w-[500px] h-auto rounded-lg overflow-hidden shadow-lg relative">
                                            <video
                                                autoPlay
                                                loop
                                                muted
                                                controls
                                                className="w-full h-full object-cover"
                                            >
                                                <source src={video} type="video/mp4" />
                                            </video>
                                        </div>
                                    </div>
                                </div>


                            )
                        }
                    </div>
                </section>
                <section className="relative gi-terms-conditions py-[40px] max-[767px]:py-[30px]">
                    <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                        <div className="section-title-2 text-center min-[1600px]:max-w-[600px] mx-auto z-20 relative">
                            <h2 className="text-gray-900 bodonibook_font text-3xl font-medium">{customJewellery?.title}</h2>
                            <p className="text-gray-600 text-[14px] font-medium pt-3 uppercase">{customJewellery?.sub_title}</p>
                        </div>
                        {customJewellery?.why_omens?.length > 0 && (
                            JSON.parse(customJewellery?.why_omens)?.map((items, ind) => (
                                <div key={ind} className="grid grid-cols-1 md:grid-cols-2 gap-1 my-6 w-full items-center">
                                    <div className={`rounded-lg relative overflow-hidden ${ind % 2 != 0 ? "md:order-2" : "md:order-1"
                                        }`}>
                                        <div className="product_jewellery relative h-[300px]">
                                            <img className="w-full" src={`${IMG_BASE_URL}${items?.img}`} alt="jewellery" />
                                        </div>
                                    </div>
                                    <div className={`rounded-lg relative overflow-hidden my-auto ${ind % 2 !== 0 ? "md:order-1" : "md:order-2"
                                        }`}>
                                        <div className="section-title-2 relative p-6">
                                            <h1 className="text-gray-900 bodonibook_font text-3xl font-medium">{items?.title}</h1>
                                            <div className="border-b border-gray-600 my-3 w-[100px]"></div>
                                            <div className="text-gray-600 text-[14px] font-medium pt-5 capitalize">{items?.description}</div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}

                    </div>
                </section>

                {/* Certificate */}
                <section className="relative py-[40px] max-[767px]:py-[30px]">
                    <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                        <div className="gi-bl-block-content grid md:grid-cols-3">
                            <div className="gi-check-bill-form pb-4 col-span-2 my-auto">
                                <div className="section-title-2 relative pb-6">
                                    <h2 className="text-gray-900 bodonibook_font text-3xl font-medium">{customJewellery?.certificate_title}</h2>

                                    <div className="border-b border-gray-600 mt-3 w-[150px]"></div>
                                </div>
                                <div className="flex gap-5 flex-wrap items-center">
                                    {customJewellery?.certificate_logo && JSON.parse(customJewellery?.certificate_logo)?.map((logo, logoIndex) => (
                                        <a href='/' target='blank' key={logoIndex}><img width={120} src={`${IMG_BASE_URL}${logo}`} alt="certificate-logo" /></a>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <img src={`${IMG_BASE_URL}${customJewellery?.certificate_image}`} alt="certificate-image" />
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </>
        </div>
    )
}

export default Custom_Jewelry